<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget :title="`<h2>${contractingAuthority.name}</h2>`" customHeader collapse>
          <b-row>
            <b-col md="3" class="font-weight-bold">
              IČO: 
            </b-col>
            <b-col md="6" class="h5">
              {{String(contractingAuthority.cin).padStart(8, '0')}}
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">
              Sídlo: 
            </b-col>
            <b-col md="6">
              {{`${contractingAuthority.street}, ${contractingAuthority.city}, ${contractingAuthority.zip}`}}
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">
              Profil VO UVO: 
            </b-col>
            <b-col md="6">
              <a :href="`https://www.uvo.gov.sk/vyhladavanie-profilov/detail/${contractingAuthority.uvoId}`" target="_blank">https://www.uvo.gov.sk/vyhladavanie-profilov/detail/{{contractingAuthority.uvoId}} <i class="fa fa-external-link" aria-hidden="true"></i></a>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">
              Profil VO E-LENA: 
            </b-col>
            <b-col md="6">
              <a :href="`https://www.e-lena.sk/profil/${String(contractingAuthority.cin).padStart(8, '0')}`" target="_blank">https://www.e-lena.sk/profil/{{String(contractingAuthority.cin).padStart(8, '0')}} <i class="fa fa-external-link" aria-hidden="true"></i></a>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">
              Počet zákaziek:
            </b-col>
            <b-col md="6">
              {{contractingAuthority.submittedContracts}}
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">
              Dátum poslednej úpravy:
            </b-col>
            <b-col md="6">
              {{new Date(contractingAuthority.lastSubmittedContractDate) | moment("DD. MM. YYYY HH:mm")}}
            </b-col>
          </b-row>
        </Widget>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget title="<h2>Zákazky</h2>" customHeader collapse>
        <v-server-table v-if="this.options.contractingAuthorityId!==null" v-bind:columns="columns" v-bind:options="options" ref="table" @row-click="rowClick">
            <span slot="title" slot-scope="props">
              {{ props.row.title}}
            </span>
            <span slot="concludedOn" slot-scope="props">
              {{ new Date(props.row.concludedOn) | moment("DD. MM. YYYY") }}
            </span>
            <span slot="createdOn" slot-scope="props">
              {{ new Date(props.row.createdOn) | moment("DD. MM. YYYY HH:mm") }}
            </span>
          </v-server-table>
          <b-button block variant="primary" @click.prevent="goToOrdersPage()">
            <span>Pridať zákazku</span>
          </b-button>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget"
import Transparex from '@/services/TransparexHttp.js'
import OrderDetail from '@/components/Custom/OrderDetail'
import moment from 'moment'

export default {
  name: 'ProfilePage',
  components: { Widget },
  data: function () {
    return {
      contractingAuthority: {},
      columns: ['title', 'concludedOn', 'createdOn'],
      options: {
        filterable: false,
        sortable: [],
        skin: 'table',
        contractingAuthorityId: null,
        size: 10,
        headings: {
          title: 'Názov',
          concludedOn: 'Dátum podpisu zmluvy',
          createdOn: 'Dátum úpravy'
        },
        pagination: {
          dropdown: false,
          chunk: 5,
          edge: true,
          align: 'center',
          nav: 'fixed'
        },
        debounce: 500,
        texts: {
          count: 'Riadky {from} až {to} z {count}|{count} riadkov|1 riadok',
          noResults: 'Žiadne záznamy',
          loading: 'Načítavam údaje ...',
          filter: 'Vyhľadaj:',
          filterPlaceholder: 'názov alebo obstarávateľ',
          first: 'Začiatok',
          last: 'Koniec',
          limit: 'Počet zobrazených záznamov:'
        },
        requestFunction (data) {
          let queryString = `?contractingAuthorityId=${this.options.contractingAuthorityId}`
          queryString += `&size=${data.limit}`
          queryString += `&page=${data.page - 1}`
          queryString += `&sort=createdOn,desc`
          
          return Transparex.get('/lv/contracts' + queryString).catch(function (error) {
            this.dispatch('error', error)
          }.bind(this))
        },
        responseAdapter (resp) {
          let data = resp.data
          return {data: data.content, count: data.totalElements}
        }
      }
    }
  },  
  methods: {
    goToOrdersPage() {
      this.$router.push({ name: 'AddOrderFormularPage', params: {cin: this.$route.params.cin}})
    },
    rowClick(event) {
      this.$vuedals.open({
        name: 'order-detail-window',
        title: 'Zákazka',
        props: {
          orderData: event.row,
        },
        component: OrderDetail,
      });
    }
  },
  async created() {
    let response = await this.$transparexHttp.get('/profiles/cin/' + this.$route.params.cin)
    if (response.status === 200) {
      this.contractingAuthority = response.data
      this.options.contractingAuthorityId = this.contractingAuthority.id
    }
  },
  filters: {
    filterDate (value) {
      return value ? moment(value).format('DD. MM. YYYY') : ''
    }
  }
}
</script>

<style src="./Profile.scss" lang="scss"/>